/*
* Rates Grid
*
*/
import $ from "jquery";

// Default to Double
function gridRatesDefault() {
$('.rates-grid').each(function() {
    var grid = $(this);
    grid.find('.nav-double').each(function() {
    var double = $(this);
    double.addClass('active');
    });
});
}
gridRatesDefault();

// Activate table
function gridRatesActivate() {
$('.rates-grid').each(function() {
    var grid = $(this);
    grid.find('.rates-grid-table').each(function() {
    var double_table = $(this);
    double_table.addClass('double-active');
    });
    grid.find('.rates-dates li').first().addClass('active');
    grid.find('.rates-table').first().addClass('active');
});
}
gridRatesActivate();

// Swap Single and Double on menu button clicks
$('.rates-grid').each(function() {
var grid = $(this);

grid.find('.occupancy').each(function() {
    var occupancy = $(this);

    occupancy.find('.nav-button').each(function() {
    var nav_button = $(this); 
    
    nav_button.on('click', function(e) {
        e.preventDefault();

        if (nav_button.hasClass('nav-single')) {
        if (! nav_button.hasClass('active')) {

            nav_button.parent().find('.nav-button').each(function() {
            $(this).removeClass('active');
            });
            nav_button.addClass('active');

            grid.find('.rates-grid-table').each(function() {
            $(this).removeClass('double-active');
            $(this).addClass('single-active');
            });
        }
        
        } else if (nav_button.hasClass('nav-double')) {
        if (! nav_button.hasClass('active')) {

            nav_button.parent().find('.nav-button').each(function() {
            $(this).removeClass('active');
            });

            nav_button.addClass('active');
            grid.find('.rates-grid-table').each(function() {
            $(this).removeClass('single-active');
            $(this).addClass('double-active');
            });
        }
        }
    });
    });
});

// Swap rates tables on click of date menu
grid.find('.rates-dates').each(function() {
    var rates_dates = $(this);

    rates_dates.on( 'click', function(e) {
    e.preventDefault();

    if (! rates_dates.hasClass('expanded')) {
        rates_dates.addClass('expanded');
    } else {
        rates_dates.removeClass('expanded');
    }

    });
});
    
grid.find('.nav-dates').each( function() {
    var nav_dates = $(this); 
    var nav_target = nav_dates.data('controls');  

    // Click the dates menu
    nav_dates.on('click', function(e) {
    e.preventDefault();
    var parent = nav_dates.parent('.rate-table-dates');

    // Select new active dates and bring item + button to the top
    if (! parent.hasClass('active')) {
        grid.find('.rate-table-dates').each( function() {
        $( this ).removeClass('active');
        });
        parent.addClass('active');
        grid.find('.rates-table').each( function() {
        $( this ).removeClass('active');
        });
        grid.find( '#' + nav_target ).each( function() {
        $( this ).addClass('active');
        });
    }
    });
});
});